import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Card, CardContent, Grid, Skeleton,
  CardActions,
  CardMedia
} from "@mui/material";
import { useHistory } from "react-router-dom";
import ApiService from "../../_services/ApiService";
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";
import ReusableHeadingComponents from "../../components/reusableComponents/reusableHeadingComponents";
import { CardMediaSkeleton } from '../../components/reusableComponents/SkeletonCard';
import ReusableMuiIcons from '../../_helpers/ReusableMuiIcons';
import ReusableChip from "../../components/reusableComponents/chipSelector";

const CampaignTypeSelection = () => {
  const history = useHistory();
  const [campaignTypes, setCampaignTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ApiService.get('campaigntype')
      .then(res => {
        setCampaignTypes(res?.data?.results || []);
      })
      .catch(err => console.error("Error fetching campaign types:", err))
      .finally(() => setLoading(false));
  }, []);

  const handleCreateOffer = (id) => {
    history.push(`/create-offer/overview/${id}`);
  };

  const renderChips = (tags) =>
    (Array.isArray(tags) ? tags : []).map((tag, i) => (
      <ReusableChip
        key={i}
        label={tag}
        bgcolor="#E8E8E8"
        color="#7A7A7A"
        borderRadius="4px"
        sx={{ p: '10px 12px', fontSize: '12px' }}
      />
    ));

  return (
    <Box sx={{ p: '24px 24px 70px' }}>
      <ReusableHeadingComponents
        bacHistory
        clickHandlerBack={() => history.push("/new-offer")}
        heading="Choose Your Campaign Type"
        subHeading="Select the type of influencer marketing campaign that best fits your goals and budget"
      />

      <Grid container spacing={3} >
        {loading ? (
          Array.from({ length: 6 }).map((_, i) => (
            <Grid item xs={12} sm={6} md={6} lg={4} key={i}>
              <CardMediaSkeleton />
            </Grid>
          ))
        ) : campaignTypes.length === 0 ? (
          <Grid item xs={12}>
            <Typography textAlign="center" color="text.secondary">
              No results found.
            </Typography>
          </Grid>
        ) : (
          campaignTypes.map((campaign, index) => (
            <Grid item xs={12} sm={6} md={6} lg={4} key={index}>
              <Box sx={{ height: '100%' }}>
                <Card
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    borderRadius: '10px',
                    border: '1px solid #f0f0f0',
                    "&:hover": { boxShadow: 2 },
                  }}>
                  <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ flexGrow: 1 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                        <Box sx={{ display: 'flex' }}>
                          <Box
                            sx={{
                              width: 65,
                              height: 60,
                              borderRadius: '8px',
                              backgroundColor: "#F4F7FE",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <CardMedia
                              component="img"
                              image={campaign.campaign_logo}
                              height="30"
                              sx={{ width: "50%" }}
                            />
                          </Box>
                          <Box sx={{ ml: 1 }}>
                            <Typography variant="subtitle1" fontWeight={700}>
                              {campaign.campaign_name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {campaign.description}
                            </Typography>
                          </Box>
                        </Box>

                        {campaign.campaign_name === "Store Invite" && (
                          <ReusableChip label={"Coming Soon"} bgcolor={"#83E542"} color={"#fff"} />
                        )}
                      </Box>

                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {renderChips(campaign.tags)}
                      </Box>
                    </Box>
                  </CardContent>
                  <CardActions sx={{ px: 2, pb: 2, mt: 'auto' }}>
                    <ReusableButton
                      children="Create Offer"
                      variant="contained"
                      classNames={`gn-actionbtn w-100 ${campaign?.campaign_name === "Store Invite" ? "gn-actionbtn-disabled" : ""}`}
                      onClick={() => handleCreateOffer(campaign.id)}
                      disabled={campaign?.campaign_name === "Store Invite"}
                    />
                  </CardActions>
                </Card>
              </Box>
            </Grid>
          ))
        )}
      </Grid>
    </Box>
  );
};

export default CampaignTypeSelection;
